import { type BundledLanguage, type BundledTheme, createHighlighter, type Highlighter } from "shiki";

export const SHIKI_LANGS = [
  "python",
  "javascript",
  "typescript",
  "bash",
  "go",
  "java",
  "csharp",
] as const satisfies BundledLanguage[];

export const SHIKI_THEMES = ["github-dark", "github-light"] as const satisfies BundledTheme[];

export type ShikiLang = (typeof SHIKI_LANGS)[number];

let _promise: Promise<Highlighter> | null = null;

/**
 * Returns a shared shiki Highlighter instance, initialised lazily on first call.
 * Subsequent calls return the same promise (or resolved value) with no re-init.
 */
export const getShikiHighlighter = (): Promise<Highlighter> => {
  if (!_promise) {
    _promise = createHighlighter({ themes: SHIKI_THEMES, langs: SHIKI_LANGS });
  }
  return _promise;
};
